<template>
    <div class="wrapper">
      <div class="container">
        
        <div  class="right-column" :class="{ 'hovered': isHoverRight }" @mouseover="isHoverRight = true">
          <h2>forget the password</h2>
          <el-form :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="forgotPasswordForm">
            <el-form-item prop="userName">
              <el-input size="medium" prefix-icon="el-icon-user" v-model="forgotPasswordForm.userName" placeholder="username"></el-input>
            </el-form-item>
            <el-form-item prop="phoneNum">
              <el-input size="medium" prefix-icon="el-icon-mobile-phone" v-model="forgotPasswordForm.phoneNum" placeholder="number"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="sendResetLink('forgotPasswordForm')">verify</el-button>
              <el-button type="danger" size="medium" @click="switchLogin">Cancel</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import request from '@/utils/request';
  import md5 from 'js-md5'
  
  export default {
    name: "Register",
    data() {
      return {
        registerUser: {
          phoneNum:'',
          userName: '',
          password: '',
          confirmPassword: ''
        },
        forgotPasswordForm: {
          userName: '',
          phoneNum :''
        },
        registerRules: {
          // 省略注册表单校验规则
        },
        forgotPasswordRules: {
            userName: [
            { required: true, message: 'please enter user name', trigger: 'blur' },
            { min: 3, max: 30, message: '3 to 12 characters in length', trigger: 'blur' }
          ],
            phoneNum:[
              {required:true,message:'Please enter phone number',trigger:'blur'},
              {min:6, max:20,message:'Cannot exceed 20 characters in length',trigger:'blur'}
            ]
        },
        isHoverRight: false,
      };
    },
    methods: {
      // 省略注册方法和注册表单校验方法
  
      switchLogin() {
        this.$router.push('/login')
      },
  
      sendResetLink(formName) {
        console.log(this.forgotPasswordForm.userName)
        this.$refs[formName].validate((valid) => {
          if (valid) {
                request.get("/users/selectUserName",{
                    params:{
                        userName :this.forgotPasswordForm.userName,
                        phoneNum :this.forgotPasswordForm.phoneNum
                    }
                }).then(res =>{
                    if(res.code == "SUCCESS"){
                        this.$message.success("Verification successful")
                        this.$store.state.editUserName =this.forgotPasswordForm.userName
                        this.$router.push('/editPassword1')
                    }else if(res.code == "USER_NOT"){
                        this.$message("Authentication failed, wrong username")
                    }
                })
          } else {
            return false;
          }
        });
      },
  
      cancelForgotPassword() {
        this.showForgotPassword = false;
      }
    },
  };
  </script>
  
  <style scoped>
  .wrapper {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #04112b;
  }
  
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
  }
  
  .right-column {
    flex: 1;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.5s ease, box-shadow 0.5s ease;
    transform-origin: center center;
  }
  
  .right-column.hovered {
    transform: perspective(1000px) scale(1.2) rotateY(0deg);
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  }
  
  .el-input {
    margin-bottom: 10px;
  }
  
  .el-button {
    margin-top: 10px;
  }
  
  .forgot-password-link {
    color: #999;
    font-size: 12px;
    margin-left: 10px;
  }
  </style>